import React from 'react';

import tapaStyles from './tapa.module.css';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import { KeyboardDatePicker, TimePicker } from '@material-ui/pickers';
import {
  RadioButtonChecked,
  RadioButtonUnchecked,
  CalendarToday,
} from '@material-ui/icons';
import moment, { Moment } from 'moment';
import OrderDashboard from '../../models/OrderDashboard';

const styles = (theme: Theme) =>
  createStyles({
    input: {
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      paddingRight: '6px',
    },
    blue: {
      color: 'var(--primaryblue)',
    },
    inputtextField: {
      display: 'none'
    },
    dateInput: {
      color: 'white',
      paddingTop: '0',
      width: '130px'
    },
    helperText: {
      color: 'red',
    },
    ordersWrapper: {
      display: 'flex',
    }
  });

interface tapaOrdersComponentProps {
  unlinkedOrders: Array<OrderDashboard>;
  classes: any;
  date: Moment;
  dateChange: (type: string, date: any) => void;
  handleChange: (type: string, event: any) => void;
  selectedOrder: OrderDashboard;
};

const tapaOrdersComponent = (props: tapaOrdersComponentProps) => {
  const orders: Array<JSX.Element> = props.unlinkedOrders.map(
    (item: OrderDashboard) => {
      return (
        <FormControlLabel
          control={
            <Radio
              value={ item.id }
              checked={ props.selectedOrder && item.id === props.selectedOrder.id }
              icon={<RadioButtonUnchecked />}
              checkedIcon={<RadioButtonChecked />}
            />
          }
          className={ tapaStyles.tapaLabelWrapper }
          label={
            <Typography
              className={ tapaStyles.docLabel }>
              <p>{ item.driver_name }</p>
              <p>{ item.delivery_company_name }</p>
              <p>
                { item.order_type === 'do' ? 'Drop Off' : item.order_type === 'po' ? 'Pick Up' : item.isRfs ? 'RFS' : 'Interline' }  - Order # { item.number }
              </p>
              <p>
                Check In -
                { moment(item.pickup_time_timestamp).format('DD MMM YY HH:mm') }
              </p>
            </Typography>
          }
        />
      );
    },
  );
  const { classes } = props;

  return (
    <div className={ tapaStyles.documentCol }>
      <div className={ classes.ordersWrapper }>
        <div className={ classes.input }>
          Not linked orders -
        </div>
        <KeyboardDatePicker
          autoOk
          id='datepicker'
          label=''
          className={ `${classes.dateInput} ${classes.ipField}` }
          value={ props.date }
          format={'DD MMM YYYY'}
          onChange={ (date: any) => props.dateChange('orders', date) }
          InputProps={{
            className: classes.dateInputField
          }}
          InputLabelProps={{
            className: classes.inputtextField
          }}
        />
      </div>
      <RadioGroup
        aria-label='notifyBy'
        name='notifyBy'
        onChange={ (e: any) => props.handleChange('order', e) }
        className={ tapaStyles.infoParent }>
        { orders }
      </RadioGroup>
    </div>
  );
};

export default withStyles(styles)(tapaOrdersComponent);
